import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'

export const CouponsSavingsQuery = 'Coupons Savings'
export const getCouponsSavingsQueryKey = (params: {
  storeParams: StoreParams
  currentActiveOrderId: number | null
  userId: number
}) => [CouponsSavingsQuery, params] as const
